// extracted by mini-css-extract-plugin
module.exports = {"number":"NumberBlock_number__r3L9S","title":"NumberBlock_title__OWK1j","bodyText":"NumberBlock_bodyText__DTYV_"};